// extracted by mini-css-extract-plugin
export var label = "_he-2";
export var slideContainer = "_he-0";
export var slider = "_he-1";